const {ChildDatasetConfiguration} = require("./configuration/child-dataset-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const ChildDatasetStepTabs = {
    configuration: ChildDatasetConfiguration,
    preview: PreviewTab,
};
exports.ChildDatasetStepTabs = ChildDatasetStepTabs;
